<template>
    <el-dialog v-model="dialogShow" title="编辑词汇" width="550px" align-center="true" :before-close="handleClose" destroy-on-close>

        <div class="inrect vh-flex">
            <div class="dialog_lb">词汇</div>
            <div class="mgt10">
                <input type="text" v-model="word" class="line_input" placeholder="请输入词汇" />
            </div>
            <div class="dialog_lb mgt20">译文</div>
            <div class="mgt10">
                <input type="text" v-model="translate" class="line_input" placeholder="请输入翻译" />
            </div>
            <div class="dialog_lb mgt20">音标</div>
            <div class="mgt10">
                <input type="text" v-model="symbol" class="line_input" placeholder="请输入音标" />
            </div>
            <div class="vh-full"></div>
            <SaveButton @buttonClick="saveClick"></SaveButton>
        </div>
    </el-dialog>
</template>

<script>
import SaveButton from '@/components/SaveButton.vue'
import httpClient from '@/commom/http/httpClient'
export default {
    name: 'EditWordDialog',
    components: {
        SaveButton
    },
    props: {
        show: Boolean,
        wordItem: Object
    },
    watch: {
        show: function (nval, old) {
            this.dialogShow = nval
            if (nval) {
                this.loadWord()
            }
        },

    },
    data() {
        return {
            dialogShow: this.showDialog,
            word: "",
            translate: "",
            symbol: ""
        }
    },
    mounted: function () {
        if (this.wordItem) {
            this.loadWord()
        }
    },
    methods: {
        ///加载词汇
        loadWord: function () {
            this.word = this.wordItem.word
            this.translate = this.wordItem.translate
            this.symbol = this.wordItem.symbol
        },
        handleClose: function () {
            this.selectButton(false)
        },
        ///选择按钮
        selectButton: function (result, data) {
            var res = {
                confrim: result,
                data: data
            }
            this.$emit("selectButton", res)
        },
        saveClick: function (result) {
            if (!result) {
                this.selectButton(false)
                return
            }
            var word = this.word.trim()
            if (word.length == 0) {
                this.$message({ message: '请输入词汇' })
                return
            }
            var model = {
                Word: word,
                Translate: this.translate,
                Symbol: this.symbol
            }
            var req = {
                wordId: this.wordItem.wordId,
                model: JSON.stringify(model)
            }
            var that = this
            httpClient.invoke("WordItemAPI.UpdateWord", req, function (res) {
                if (res.error) {
                    that.$message({ message: res.error })
                    return
                }
                if (!res.success) {
                    that.$message({ message: res.message })
                    return
                }

                that.selectButton(true, model)
            })
        },


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.inrect {
    height: 450px;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 15px;
}
</style>